<div class="main-div">
    <p class="text-div">The project '{{projectID}}' has been added to the queue. You can track the progress from the
        'Review In Progress' section in Dashboard. Once review is complete, you can check the results from the
        'Reviewed' section.</p>
    <div class="button-div">
        <button mat-flat-button color="warn" class="queuedButton1" (click)="goToDashboard()"> Dashboard</button>
        <button mat-flat-button color="warn" class="queuedButton2" (click)="newQueuedReview()"> New Review</button>
    </div>
</div>